/**
 * Heatmap.js
 *
 * @class   Heatmap
 * @author  Dan Goldshlack
 *
 */

import React from 'react';
import D3 from 'd3';

export default React.createClass({

	displayName: 'Heatmap',

	propTypes: {

	},

	render() {

		return <h3>Heatmap</h3>

	}

});



/** WEBPACK FOOTER **
 ** ./src/charts/heatmap/Heatmap.js
 **/